import DonsList from "../../components/Dons/DonsList";


function Dons(){

  const startYear=2025;
  const now=new Date();
  const years=[];
  for(let i=startYear;i<=now.getFullYear();i++){
    years.push(i);
  }
  return (
  <div>

    <DonsList   />

    <div>
      <form action='/ws/dons/years'>
        <select name="year">
          <option value="">-----</option>
          {years.map((i)=>
            <option key={i} value={i}>{i}</option>
          )}
        </select>
        <button type="submit">export</button>
      </form>

    </div>

  </div>
  );
}
export default Dons;